import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.385 2.75c-1.016 0-1.996.42-2.723 1.176A4.15 4.15 0 0 0 6.519 6.8c0 1.866.487 3.521 1.233 4.686.752 1.174 1.7 1.764 2.633 1.764.931 0 1.88-.59 2.632-1.764.747-1.165 1.233-2.82 1.233-4.686a4.15 4.15 0 0 0-1.142-2.874 3.78 3.78 0 0 0-2.723-1.176m-3.805.136a5.28 5.28 0 0 1 3.805-1.636c1.432 0 2.8.592 3.804 1.636A5.65 5.65 0 0 1 15.75 6.8c0 2.11-.547 4.055-1.47 5.496-.773 1.205-1.857 2.12-3.145 2.38v.124c0 .614-.235 1.208-.66 1.651a2.26 2.26 0 0 1-1.629.699H6.538a.76.76 0 0 0-.547.239.88.88 0 0 0-.241.611.75.75 0 0 1-1.5 0c0-.614.234-1.208.66-1.651a2.26 2.26 0 0 1 1.628-.699h2.308a.76.76 0 0 0 .547-.239.88.88 0 0 0 .242-.611v-.125c-1.288-.26-2.373-1.174-3.145-2.38-.924-1.44-1.47-3.385-1.47-5.495a5.65 5.65 0 0 1 1.56-3.914M9.635 5.2a.75.75 0 0 1 .75-.75c.616 0 1.201.255 1.628.699s.66 1.037.66 1.651a.75.75 0 0 1-1.5 0 .88.88 0 0 0-.241-.612.76.76 0 0 0-.547-.238.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }